import { fetchRecommendation } from '@/fetch';

// 服务端透传字段 - 全局共享, 用于维护推荐请求的上下文状态
let transparent = '';
// 缓存上一次请求的推荐 id 列表 - 全局共享, 用于去重和分页
let prevRecommendIdList: string[] = [];
// 注意：这些变量在多个组件间共享是故意的设计, 确保推荐系统的连续性

/**
 * 重置推荐状态
 */
const resetState = () => {
    transparent = '';
    prevRecommendIdList = [];
};

/**
 * 获取推荐列表
 * @returns 推荐列表
 */
const queryList = async (data: {
    contentTextSwitch: boolean;
    categoryId: string;
}) => {
    const res = await fetchRecommendation({
        contentTextSwitch: data.contentTextSwitch,
        issuedList: prevRecommendIdList,
        transparent,
        categoryId: data.categoryId,
    });

    if (!res || res.feedsList.length === 0) {
        return [];
    }

    // 透传字段
    transparent = res.transparent;
    // 记录推荐 id 列表
    prevRecommendIdList = [
        ...res.feedsList.map((item) => item.imageId),
        ...prevRecommendIdList,
    ];
    // 添加新的推荐
    return res.feedsList;
};

export { queryList, resetState };
